"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const net_1 = require("net");
const url_1 = require("url");
const dns_resolve_1 = __importDefault(require("./dns-resolve"));
async function parseHost(url, headers) {
    const parsedUrl = url_1.parse(url);
    const host = headers.get('host') || parsedUrl.host;
    if (!host) {
        throw new TypeError('Unable to determine Host');
    }
    headers.set('host', host);
    const ip = net_1.isIP(parsedUrl.hostname || '');
    if (ip === 0) {
        if (!parsedUrl.hostname) {
            throw new Error('Unable to determine hostname');
        }
        const newUrl = new URL(parsedUrl.href);
        newUrl.hostname = await dns_resolve_1.default(parsedUrl.hostname);
        url = newUrl.href;
    }
    return [url, host];
}
exports.default = parseHost;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2phcm1vL2dpdC90dXJpc3QtY2xvdWQvZmV0Y2gvc3JjL3BhcnNlLWhvc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw2QkFBMkI7QUFDM0IsNkJBQXdDO0FBRXhDLGdFQUFvQztBQUVyQixLQUFLLFVBQVUsU0FBUyxDQUFDLEdBQVcsRUFBRSxPQUFnQjtJQUNwRSxNQUFNLFNBQVMsR0FBRyxXQUFRLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDaEMsTUFBTSxJQUFJLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxNQUFNLENBQUMsSUFBSSxTQUFTLENBQUMsSUFBSSxDQUFDO0lBRW5ELElBQUksQ0FBQyxJQUFJLEVBQUU7UUFDVixNQUFNLElBQUksU0FBUyxDQUFDLDBCQUEwQixDQUFDLENBQUM7S0FDaEQ7SUFFRCxPQUFPLENBQUMsR0FBRyxDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUMsQ0FBQztJQUUxQixNQUFNLEVBQUUsR0FBRyxVQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsSUFBSSxFQUFFLENBQUMsQ0FBQztJQUMxQyxJQUFJLEVBQUUsS0FBSyxDQUFDLEVBQUU7UUFDYixJQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsRUFBRTtZQUN4QixNQUFNLElBQUksS0FBSyxDQUFDLDhCQUE4QixDQUFDLENBQUM7U0FDaEQ7UUFPRCxNQUFNLE1BQU0sR0FBRyxJQUFJLEdBQUcsQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDdkMsTUFBTSxDQUFDLFFBQVEsR0FBRyxNQUFNLHFCQUFPLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1FBQ3BELEdBQUcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDO0tBQ2xCO0lBRUQsT0FBTyxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsQ0FBQztBQUNwQixDQUFDO0FBM0JELDRCQTJCQyJ9